export const OPEN_MODAL = 'HOW_TO_START_MODAL.OPEN_MODAL';
export type OPEN_MODAL_TYPE = typeof OPEN_MODAL;
export const CLOSE_MODAL = 'HOW_TO_START_MODAL.CLOSE_MODAL';
export type CLOSE_MODAL_TYPE = typeof CLOSE_MODAL;
